// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cbe2196a","239":"598d88a9","453":"369d52dc","455":"0737b438"}[chunkId] + ".chunk.js";
};